module.exports = __webpack_public_path__ + "static/media/flashDanger.cf5c71da.svg";